import * as React from 'react';
import { LineItem, LineItemMedia, LineItemContent } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { RemoveLineItemContainer } from '../containers/RemoveLineItemContainer.js';
import { PricesContainer } from '../containers/PricesContainer.js';
import { DiscountContainer } from '../containers/DiscountContainer.js';
import { ContactLensSpecsContainer } from '../containers/ContactLensSpecsContainer.js';

const ContactLensesBundleBenelux = ({ lineItem , settings , labels , isLineItemClickable =true  })=>{
    const { readOnly  } = settings;
    const { discount , imageUrl , isGift , price , name , lensType , solutionImageUrl , solutionName , leftEyeProduct , rightEyeProduct , productUrl ,  } = lineItem;
    const { iconLeftEye , iconRightEye , monthlySubscription  } = labels;
    return /*#__PURE__*/ React.createElement("div", {
        className: "line-item--contact-lenses-bundle-benelux"
    }, /*#__PURE__*/ React.createElement(LineItem, {
        className: "line-item line-item--contact-lenses-bundle-benelux-item"
    }, /*#__PURE__*/ React.createElement(LineItemMedia, {
        className: "line-item__media",
        type: "image",
        href: isLineItemClickable ? productUrl : undefined,
        imageUrl: imageUrl,
        imageAlt: name
    }), /*#__PURE__*/ React.createElement(LineItemContent, {
        className: "line-item__content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "line-item__description"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2",
        className: "line-item__title"
    }, name), /*#__PURE__*/ React.createElement(Text, {
        component: "span",
        variant: "body"
    }, lensType), readOnly && /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head"
    }, monthlySubscription)), /*#__PURE__*/ React.createElement("div", {
        className: "line-item__quantity-and-price"
    }, !readOnly && !isGift && /*#__PURE__*/ React.createElement("div", {
        className: "line-item__quantity"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "line-item__quantity-selector"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "line-item__delete-btn"
    }, /*#__PURE__*/ React.createElement(RemoveLineItemContainer, {
        lineItem: lineItem
    })), /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head"
    }, monthlySubscription))), /*#__PURE__*/ React.createElement(PricesContainer, {
        discount: price.total.discount,
        originalPrice: price.total.original,
        totalPrice: price.total.gross
    })), /*#__PURE__*/ React.createElement("div", {
        className: "line-item__specs-and-stock"
    }), /*#__PURE__*/ React.createElement(DiscountContainer, {
        discount: discount
    }))), /*#__PURE__*/ React.createElement(LineItem, {
        className: "line-item line-item--contact-lenses-bundle-benelux-item"
    }, /*#__PURE__*/ React.createElement(LineItemMedia, {
        className: "line-item__media",
        type: "icon",
        iconName: "left-eye",
        iconLabel: iconLeftEye
    }), /*#__PURE__*/ React.createElement(LineItemContent, {
        className: "line-item__content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "line-item__specs-and-stock"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "line-item__specs"
    }, /*#__PURE__*/ React.createElement(Text, {
        component: "span",
        variant: "body-head"
    }, leftEyeProduct.name), /*#__PURE__*/ React.createElement(ContactLensSpecsContainer, {
        specs: leftEyeProduct.specs
    }))))), /*#__PURE__*/ React.createElement(LineItem, {
        className: "line-item line-item--contact-lenses-bundle-benelux-item"
    }, /*#__PURE__*/ React.createElement(LineItemMedia, {
        className: "line-item__media",
        type: "icon",
        iconName: "right-eye",
        iconLabel: iconRightEye
    }), /*#__PURE__*/ React.createElement(LineItemContent, {
        className: "line-item__content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "line-item__specs-and-stock"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "line-item__specs"
    }, /*#__PURE__*/ React.createElement(Text, {
        component: "span",
        variant: "body-head"
    }, rightEyeProduct.name), /*#__PURE__*/ React.createElement(ContactLensSpecsContainer, {
        specs: rightEyeProduct.specs
    }))))), solutionName && /*#__PURE__*/ React.createElement(LineItem, {
        className: "line-item line-item--contact-lenses-bundle-benelux-item"
    }, /*#__PURE__*/ React.createElement(LineItemMedia, {
        className: "line-item__media",
        type: "image",
        imageUrl: solutionImageUrl,
        imageAlt: solutionName
    }), /*#__PURE__*/ React.createElement(LineItemContent, {
        className: "line-item__content"
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head"
    }, solutionName))));
};

export { ContactLensesBundleBenelux };
//# sourceMappingURL=ContactLensesBundleBenelux.js.map
